export default __webpack_public_path__ + "static/media/Armguards of the Triumphant.81664300.jpg";